module.exports = __webpack_public_path__ + "static/img/24.d1bcca2d.png";